module.exports = __webpack_public_path__ + "static/img/explain.8a203c60.png";